import * as t from './actionTypes';

export const fetchUserPreferencesRequest = (data?: any) => ({
  type: t.FETCH_USER_PREFERENCES_REQUEST,
  ...data,
});
export const fetchUserPreferencesResponse = (data: any) => ({
  type: t.FETCH_USER_PREFERENCES_RESPONSE,
  ...data,
});

export const updateUserProfileRequest = (data: any) => ({
  type: t.UPDATE_USER_PROFILE_REQUEST,
  ...data,
});
export const updateUserProfileResponse = () => ({ type: t.UPDATE_USER_PROFILE_RESPONSE });

export const userPreferencesErrorsRequest = (data: any) => ({
  type: t.USER_PREFERENCES_ERRORS_REQUEST,
  ...data,
});
export const userPreferencesErrorsResponse = (data: any) => ({
  type: t.USER_PREFERENCES_ERRORS_RESPONSE,
  ...data,
});

export const resetPasswordRequest = (data: any) => ({ type: t.RESET_PASSWORD_REQUEST, ...data });

export const copyToClipboard = (scratchCodes: string) => ({
  type: t.COPY_TO_CLIPBOARD,
  scratchCodes,
});
